import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import React from 'react';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkCard } from 'uitk-react-cards';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { MinMax, UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface ILodgingCardProps {
  title: string;
  description: string;
  href: string;
  linkTitle: string;
  type: string;
  imageLink: string;
}
const LodgingCard = ({ title, description, href, linkTitle, type, imageLink }: ILodgingCardProps) => {
  const lodgingContentNode = (
    <div>
      <UitkSpacing margin={{ blockend: 'four' }}>
        <UitkText size={600} theme="emphasis" weight="medium">
          {title}
        </UitkText>
      </UitkSpacing>
      <UitkSpacing margin={{ blockend: 'four' }}>
        <UitkText size={300} theme="default">
          {description}
        </UitkText>
      </UitkSpacing>
      <UitkTertiaryButton tag="a" alignLabelToContent="start" href={href}>
        {linkTitle}
      </UitkTertiaryButton>
    </div>
  );
  const image = (
    <UitkFigure imageFit={type === 'vrbo' ? 'cover' : 'contain'} style={{ backgroundColor: '#001193' }}>
      <UitkImage alt={''} src={imageLink} />
    </UitkFigure>
  );

  const largeMediumView = (
    <UitkSpacing margin={type === 'vrbo' ? { blockstart: 'six' } : { blockend: 'six' }}>
      <UitkCard border>
        <UitkLayoutGrid columns={[MinMax('18x', '1fr'), MinMax('min-content', '2fr')]}>
          <UitkLayoutGridItem>{image}</UitkLayoutGridItem>
          <Viewport>
            <ViewLarge>
              <UitkSpacing padding={{ block: 'six', inline: 'twelve' }}>
                <UitkLayoutGridItem>{lodgingContentNode}</UitkLayoutGridItem>
              </UitkSpacing>
            </ViewLarge>
            <ViewMedium>
              <UitkSpacing padding={{ block: 'six', inline: 'twelve' }}>
                <UitkLayoutGridItem>{lodgingContentNode}</UitkLayoutGridItem>
              </UitkSpacing>
            </ViewMedium>
          </Viewport>
        </UitkLayoutGrid>
      </UitkCard>
    </UitkSpacing>
  );
  return (
    <Viewport>
      <ViewLarge>{largeMediumView}</ViewLarge>
      <ViewMedium>{largeMediumView}</ViewMedium>
      <ViewSmall>
        <div>
          <UitkSpacing margin={type === 'vrbo' ? { blockstart: 'six' } : { blockend: 'six' }}>
            <UitkCard border>
              <UitkLayoutFlex direction="column">
                <UitkLayoutFlexItem>
                  <UitkLayoutGridItem>{image}</UitkLayoutGridItem>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkSpacing padding={{ block: 'six', inline: 'six' }}>
                    <UitkLayoutGridItem>{lodgingContentNode}</UitkLayoutGridItem>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkCard>
          </UitkSpacing>
        </div>
      </ViewSmall>
    </Viewport>
  );
};

export default LodgingCard;
